import React from "react";
import PageBase from "../../../components/PageBase";

import './Test.scss';

const Test = props => {
	return (
		<PageBase title="Test">
		</PageBase>
	)
};

export default Test;
